var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenInNewLinkFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.222 22a2.14 2.14 0 0 1-1.57-.653A2.14 2.14 0 0 1 2 19.777V4.223q0-.915.653-1.57A2.14 2.14 0 0 1 4.223 2h6.666a1.111 1.111 0 0 1 0 2.222H4.222v15.556h15.556V13.11a1.111 1.111 0 0 1 2.222 0v6.667a2.14 2.14 0 0 1-.653 1.57 2.14 2.14 0 0 1-1.57.652zm6-6.667a1.1 1.1 0 1 1-1.556-1.556l9.556-9.555h-2.889a1.111 1.111 0 0 1 0-2.222h5.111C21.304 2 22 2.696 22 3.556v5.11a1.111 1.111 0 1 1-2.222 0V5.779z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNewLinkFill);
export default __webpack_public_path__ + "static/media/open_in_new_link_fill.30508b138cfa6760dc74a84a3a91b68a.svg";
export { ForwardRef as ReactComponent };